export default "__VITE_ASSET__ab35320f__"